import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setIsLoggedIn, setUserInfo, setUserInfo2 } from "../reduxToolkit/redux";
import { useNavigate } from 'react-router-dom';
import { SiNaver } from 'react-icons/si';
import fnc from '../mymod/commFunction';

function NaverLogin() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const svrUrl = process.env.REACT_APP_SERVER_URL;
    const naverClientId = process.env.REACT_APP_NAVER_CLIENT_ID;

    const handleNaverLogin = () => {
        try {
            if (!naverClientId) {
                alert('REACT_APP_NAVER_CLIENT_ID 환경변수가 설정되지 않았습니다.');
                return;
            }

            const state = Math.random().toString(36).substring(2, 11);
            const currentUrl = window.location.origin + window.location.pathname;
            const naverLoginUrl = `https://nid.naver.com/oauth2.0/authorize?` +
                `response_type=code&` +
                `client_id=${encodeURIComponent(naverClientId)}&` +
                `redirect_uri=${encodeURIComponent(currentUrl)}&` +
                `state=${state}&` +
                `scope=name,email,mobile`;
            
            sessionStorage.setItem('naver_state', state);
            window.location.href = naverLoginUrl;
            
        } catch (error) {
            console.error('네이버 로그인 오류:', error);
            alert('네이버 로그인 중 오류가 발생했습니다.');
        }
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const error = urlParams.get('error');
        const errorDescription = urlParams.get('error_description');
        
        if (!code && !error) return;
        
        if (error) {
            let errorMessage = '네이버 로그인에 실패했습니다.';
            if (error === 'access_denied') {
                errorMessage = '네이버 로그인이 취소되었습니다.';
            } else if (errorDescription) {
                errorMessage = `네이버 로그인 에러: ${errorDescription}`;
            }
            alert(errorMessage);
            window.history.replaceState({}, document.title, "/");
            return;
        }
        
        if (code) {
            exchangeCodeForToken(code, state);
        }
    }, []);

    const exchangeCodeForToken = async (code, state) => {
        try {
            // 토큰 교환
            const tokenResponse = await fetch(`${svrUrl}/naver/token`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ code, state })
            });
            
            if (!tokenResponse.ok) {
                throw new Error(`토큰 교환 실패: ${tokenResponse.status}`);
            }
            
            const tokenData = await tokenResponse.json();
            if (!tokenData.success || !tokenData.access_token) {
                throw new Error(tokenData.error || '토큰을 받을 수 없습니다');
            }
            
            // 사용자 정보 요청
            const userResponse = await fetch(`${svrUrl}/naver/userinfo`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ access_token: tokenData.access_token })
            });
            
            if (!userResponse.ok) {
                throw new Error(`사용자 정보 요청 실패: ${userResponse.status}`);
            }
            
            const userData = await userResponse.json();
            if (!userData.success || !userData.user) {
                throw new Error(userData.error || '사용자 정보를 받을 수 없습니다');
            }
            
            // 로그인 처리
            const user = userData.user;
            window.history.replaceState({}, document.title, "/");//페이지 새로고침 방지 (social login은 필수)
            fncInsertSocialLogin('NAVER', user.id, user.nickname || '네이버사용자', user.profile_image || '');
            
        } catch (error) {
            console.error('네이버 로그인 처리 실패:', error);
            alert('네이버 로그인 처리 중 오류가 발생했습니다.');
        }
    };

    function fncInsertSocialLogin(acaCode, id, nickname, profile_image) {
        fnc.sendAxios('/socialLoginRoutes/insert/socialLogin', { acaCode, id, nickname, profile_image, isSocialLogin: 'Y' }, (res) => {
            if (res.success) {
                console.log(res);
                fncSelectSocialLogin(id);
            } else {
            alert('저장에 실패했습니다.');
            console.log(res);
            }
        });
    
    }

    function fncSelectSocialLogin(id) {
        fnc.sendAxios('/socialLoginRoutes/select/socialLogin', { id }, (res) => {
            if (res && res.length > 0) {
                dispatch(setUserInfo2({
                    acaCode: res[0].acaCode || '',
                    nickname: res[0].nickname || '',
                    email: res[0].email || '',
                    id: res[0].id || '',
                    id2: res[0].id2 || '',//naver id 등 social login id 닉네임 아이디 임
                    profile_image: res[0].profile_image || '',
                    uid: res[0].uid || '' // firebase uid
                }));

                console.log(res, 'userinfo2 res');
                dispatch(setIsLoggedIn(true));
                navigate('/menu');
            } else {
                alert('정보가 올바르지 않습니다.')
                console.log(res,"속성이 obj 내에 없습니다.");
            }
        });
    }
    //========================================================= 

    return (
        <button className="social-btn naver-btn" onClick={handleNaverLogin}>
            <SiNaver className="social-icon" />
            <span>네이버로 로그인</span>
        </button>
    );
}

export default NaverLogin;